import { ref, computed } from 'vue';
import { countProofreadTextLength } from '../utils/helper';
export function useTextLength(maxInputTextLength = 1000) {
    //テキストの長さ
    const textLength = ref(0);
    const maxTextLength = maxInputTextLength;
    const setTextLength = (targetElementId) => {
        const target = document.getElementById(targetElementId);
        if (!target) {
            textLength.value = 0;
            return;
        }
        textLength.value = countProofreadTextLength(target.innerText);
    };
    const textCounterClass = computed(() => {
        return textLength.value > maxTextLength ? 'u-color--red u-text--bold' : '';
    });
    return {
        textLength,
        maxTextLength,
        textCounterClass,
        setTextLength,
    };
}
